import React from "react";

export default function Dashboard() {
    

    return (
        <React.Fragment>
            <div className="box">
                <div className="box-body">
                        <h4 className="box-title mb-sm-0 mb-0 flex-grow-1">
                            Dashboard
                        </h4>
                    
                </div>
            </div>


        </React.Fragment>
    )
}